export const COUNTRIES_MAP = {
	afghanistan: 'AF',
	åland_islands: 'AX',
	albania: 'AL',
	algeria: 'DZ',
	american_samoa: 'AS',
	andorra: 'AD',
	angola: 'AO',
	anguilla: 'AI',
	antarctica: 'AQ',
	antigua_and_barbuda: 'AG',
	argentina: 'AR',
	armenia: 'AM',
	aruba: 'AW',
	australia: 'AU',
	austria: 'AT',
	azerbaijan: 'AZ',
	bahrain: 'BH',
	bahamas: 'BS',
	bangladesh: 'BD',
	barbados: 'BB',
	belarus: 'BY',
	belgium: 'BE',
	belize: 'BZ',
	benin: 'BJ',
	bermuda: 'BM',
	bhutan: 'BT',
	bolivia: 'BO',
	bonaire: 'BES',
	bosnia_and_herzegovina: 'BA',
	botswana: 'BW',
	bouvet_island: 'BV',
	brazil: 'BR',
	british_indian_ocean_territory: 'IO',
	brunei_darussalam: 'BN',
	bulgaria: 'BG',
	burkina_faso: 'BF',
	burundi: 'BI',
	cambodia: 'KH',
	cameroon: 'CM',
	canada: 'CA',
	cape_verde: 'CV',
	cayman_islands: 'KY',
	central_african_republic: 'CF',
	chad: 'TD',
	chile: 'CL',
	china: 'CN',
	christmas_island: 'CX',
	colombia: 'CO',
	comoros: 'KM',
	congo: 'CG',
	republic_of_congo: 'CD',
	cook_islands: 'CK',
	costa_rica: 'CR',
	"côte_d'ivoire": 'CI',
	croatia: 'HR',
	cuba: 'CU',
	curaçao: 'CW',
	cyprus: 'CY',
	czech_republic: 'CZ',
	denmark: 'DK',
	djibouti: 'DJ',
	dominica: 'DM',
	dominican_republic: 'DO',
	ecuador: 'EC',
	egypt: 'EG',
	el_salvador: 'SV',
	equatorial_guinea: 'GQ',
	eritrea: 'ER',
	estonia: 'EE',
	ethiopia: 'ET',
	falkland_islands: 'FK',
	faroe_islands: 'FO',
	fiji: 'FJ',
	finland: 'FI',
	france: 'FR',
	french_guiana: 'GF',
	french_polynesia: 'PF',
	french_southern_territories: 'TF',
	gabon: 'GA',
	gambia: 'GM',
	georgia: 'GE',
	germany: 'DE',
	ghana: 'GH',
	gibraltar: 'GI',
	greece: 'GR',
	greenland: 'GL',
	grenada: 'GD',
	guadeloupe: 'GP',
	guam: 'GU',
	guatemala: 'GT',
	guernsey: 'GG',
	guinea: 'GN',
	guinea_bissau: 'GW',
	guyana: 'GY',
	haiti: 'HT',
	heard_island_and_mcdonald_islands: 'HM',
	holy_see: 'VA',
	honduras: 'HN',
	hong_kong: 'HK',
	hungary: 'HU',
	iceland: 'IS',
	india: 'IN',
	indonesia: 'ID',
	iran: 'IR',
	iraq: 'IQ',
	ireland: 'IE',
	isle_of_man: 'IM',
	israel: 'IL',
	italy: 'IT',
	jamaica: 'JM',
	japan: 'JP',
	jersey: 'JE',
	jordan: 'JO',
	kazakhstan: 'KZ',
	kenya: 'KE',
	kiribati: 'KI',
	north_korea: 'KP',
	south_korea: 'KR',
	kuwait: 'KW',
	kyrgyzstan: 'KG',
	lao: 'LA',
	latvia: 'LV',
	lebanon: 'LB',
	lesotho: 'LS',
	liberia: 'LR',
	libya: 'LY',
	liechtenstein: 'LI',
	lithuania: 'LT',
	luxembourg: 'LU',
	macao: 'MO',
	macedonia: '',
	madagascar: 'MG',
	malawi: 'MW',
	malaysia: 'MY',
	maldives: 'MV',
	mali: 'ML',
	malta: 'MT',
	marshall_islands: 'MH',
	martinique: 'MQ',
	mauritania: 'MR',
	mauritius: 'MU',
	mayotte: 'YT',
	mexico: 'MX',
	micronesia: 'FM',
	moldova: 'MD',
	monaco: 'MC',
	mongolia: 'MN',
	montenegro: 'ME',
	montserrat: 'MS',
	morocco: 'MA',
	mozambique: 'MZ',
	myanmar: 'MM',
	namibia: 'NA',
	nauru: 'NR',
	nepal: 'NP',
	netherlands: 'NL',
	new_caledonia: 'NC',
	new_zealand: 'NZ',
	nicaragua: 'NI',
	niger: 'NE',
	nigeria: 'NG',
	niue: 'NU',
	norfolk_island: 'NF',
	northern_mariana_islands: 'MP',
	norway: 'NO',
	oman: 'OM',
	pakistan: 'PK',
	palau: 'PW',
	palestine: 'PS',
	panama: 'PA',
	papua_new_guinea: 'PG',
	paraguay: 'PY',
	peru: 'PE',
	philippines: 'PH',
	pitcairn: 'PN',
	poland: 'PL',
	portugal: 'PT',
	puerto_rico: 'PR',
	qatar: 'QA',
	réunion: 'RE',
	romania: 'RO',
	russian_federation: 'RU',
	rwanda: 'RW',
	saint_barthélemy: 'BL',
	saint_helena_ascension_and_tristan_da_cunha: 'SH',
	saint_kitts_and_nevis: 'KN',
	saint_lucia: 'LC',
	saint_martin: 'MF',
	saint_pierre_and_miquelon: 'PM',
	saint_vincent_and_the_grenadines: 'VC',
	samoa: 'WS',
	san_marino: 'SM',
	sao_tome_and_principe: 'ST',
	saudi_arabia: 'SA',
	senegal: 'SN',
	serbia: 'RS',
	seychelles: 'SC',
	sierra_leone: 'SL',
	singapore: 'SG',
	sint_maarten: 'MF',
	slovakia: 'SK',
	slovenia: 'SI',
	solomon_islands: 'SB',
	somalia: 'SO',
	south_africa: 'ZA',
	south_georgia_and_the_south_sandwich_islands: 'GS',
	south_sudan: 'SS',
	spain: 'ES',
	sri_lanka: 'LK',
	sudan: 'SD',
	suriname: 'SR',
	svalbard_and_jan_mayen: 'SJ',
	swaziland: '',
	sweden: 'SE',
	switzerland: 'CH',
	syrian_arab_republic: 'SY',
	taiwan: 'TW',
	tajikistan: 'TJ',
	tanzania: 'TZ',
	thailand: 'TH',
	timor_leste: 'TL',
	togo: 'TG',
	tokelau: 'TK',
	tonga: 'TO',
	trinidad_and_tobago: 'TT',
	tunisia: 'TN',
	turkey: 'TR',
	turkmenistan: 'TM',
	turks_and_caicos_islands: 'TC',
	tuvalu: 'TV',
	uganda: 'UG',
	ukraine: 'UA',
	united_arab_emirates: 'AE',
	united_kingdom: 'GB',
	united_states: 'US',
	united_states_minor_outlying_islands: 'UM',
	uruguay: 'UY',
	uzbekistan: 'UZ',
	vanuatu: 'VU',
	venezuela: 'VE',
	vietnam: 'VN',
	virgin_islands_british: 'VG',
	virgin_islands_us: 'VI',
	wallis_and_futuna: 'WF',
	western_sahara: 'EH',
	yemen: 'YE',
	zambia: 'ZM',
	zimbabwe: 'ZW',
}
